import { render } from "./LoadingAlert.vue?vue&type=template&id=405221dc"
import script from "./LoadingAlert.vue?vue&type=script&lang=js"
export * from "./LoadingAlert.vue?vue&type=script&lang=js"
script.render = render

export default script